var React = require('react');

function Tilde (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M512 192v46.75c0 89-80.45 159.56-172.46 142.76-35.54-6.51-66.75-27.68-89.31-55.87l-66.52-83.15A49.25 49.25 0 0 0 96 273.25V321a32 32 0 0 1-32 32H32a32 32 0 0 1-32-32v-40.92C0 202 58.67 132.75 136.64 128.25a144.69 144.69 0 0 1 122.05 54.27l69.59 87A49.26 49.26 0 0 0 416 238.75V192a32 32 0 0 1 32-32h32a32 32 0 0 1 32 32z","className":"fa-secondary","key":1})]);
}

Tilde.defaultProps = {"viewBox":"0 0 512 512","className":"icon"};

module.exports = Tilde;

Tilde.default = Tilde;
